import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { sdrProfileApi } from '@/lib/api';
import { toast } from '@solid/ui';
import type { SdrProfile } from '@/types';

export function useSdrProfile() {
  return useQuery<SdrProfile>({
    queryKey: ['sdrProfile'],
    queryFn: () => sdrProfileApi.get(),
  });
}

export function useUpdateSdrProfile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Parameters<typeof sdrProfileApi.update>[1] }) =>
      sdrProfileApi.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sdrProfile'] });
      toast.success('AI SDR training settings have been saved.');
    },
    onError: (error: any) => {
      toast.error(error?.response?.data?.message || 'Failed to update SDR profile.');
    },
  });
}
